var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "elevation-1 my-7"
  }, [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Accounting Sales Unit Numbers")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "accent",
      "dark": ""
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" New Item ")])], 1), _vm._l(_vm.data, function (item, index) {
    return _c('v-row', {
      key: index,
      staticClass: "px-4 pb-4 mx-0",
      attrs: {
        "cols": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "3",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-select', {
      staticClass: "mt-2",
      attrs: {
        "items": _vm.availableCurrencies(item),
        "label": "Currency",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      model: {
        value: item.currency,
        callback: function ($$v) {
          _vm.$set(item, "currency", $$v);
        },
        expression: "item.currency"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "9",
        "md": "12",
        "sm": "12",
        "xs": "12"
      }
    }, [_c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "label": "Sales Unit Number",
        "hide-details": "auto",
        "dense": "",
        "outlined": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-btn', {
            staticClass: "mt-2 mr-lg-n3 mt-lg-n2",
            attrs: {
              "color": "primary",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeItem(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: item.salesUnitNumber,
        callback: function ($$v) {
          _vm.$set(item, "salesUnitNumber", $$v);
        },
        expression: "item.salesUnitNumber"
      }
    })], 1)], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }